
export enum PageTypes {
  SA_WelcomeView,
  SA_BusinessListView,
  SA_BusinessesView,
  SA_ChatView,
  SA_DrAccView,
  SA_Guides,
  SA_GuideList,
  SA_GenSetting,
  SA_ModuleSetting,
  SA_ConfigView,
  SA_Menu,
  SA_Language,
  SA_RoomSetting
}


export enum ModuleTypes {

    NotAModule,
    IsHotel,
    IsGuide,
    Header,
    MainNenu,
    KeyMenu,
    HLocation,
    CityLocation,
    Hotel,
    CityGuide,

    /*-------- for business details -------------------*/
    IsModuleHotel1,
    IsModuleHotel2,
    IsModuleHotel3,
    IsModuleHotel4,
    IsModuleHotel5,
    IsModuleHotel6,
    IsModuleHotel7,
    IsModuleHotel8,
    IsModuleHotel9,

    IsModuleGuide1,
    IsModuleGuide2,
    IsModuleGuide3,
    IsModuleGuide4,
    IsModuleGuide5,
    IsModuleGuide6,
    IsModuleGuide7,
    IsModuleGuide8,
    IsModuleGuide9,
    WVideo,
    WBgImg,
    WGData,
    Menu
}

export enum EntryTypes {
    Txt,
    Color,
    BgColor,
    Geo,
    ALL,
    SlideSett
}

export interface IItem {

    SkyAccessDesignID?: number,
    ID: string;
    StaticTxt?: string;
    MenuIcon?: string;
    VarTxt?: string;
    VarTxt2?: string
    Color?:string;
    BgColor?:string;
    PageType: PageTypes;
    EntryType: EntryTypes;
    ModuleType: ModuleTypes;
    Enabled?: boolean;
    Links?:string;
    Links2?: string; // to be removed
    Classes?:string;
    Longitude? : string;
    Latitude? : string;
    StatTranslate?:string; /* static text translation */
    FontSz?:string; /* font Size */
    FontFam?:string; /* font FontFam */
    High?:string; /* font High */
    Wdth?:string; /* font Wdth */
    _SysNumber? : number;
    _Ord? : number;
    _Eff?:string,
    _Speed? : number

}

export interface MItem {

    _SkyAccessDesignID?: number,
    _ID: string;
    _StaticTxt?: string;
    _MenuIcon?: string;
    _VarTxt?: string;
    _VarTxt2?: string
    _Color?:string;
    _BgColor?:string;
    _PageType: PageTypes;
    _EntryType: EntryTypes;
    _ModuleType: ModuleTypes;
    _Enabled?: boolean;
    _Links?:string;
    _Links2?: string; // to be removed
    _Classes?:string;
    _Longitude? : string;
    _Latitude? : string;
    _StatTranslate?:string; /* static text translation */
    _FontSz?:string; /* font Size */
    _FontFam?:string; /* font FontFam */
    _High?:string; /* font High */
    _Wdth?:string; /* font Wdth */
    _SysNumber? : number;
    _Ord? : number;
    _Eff?:string,
    _Speed? : number

}

export interface IItemList
{
  Items? : IItem[]
}

export interface IITemModuleList
{
  ItemModule?: IItem;
  Itemlist? : IItemList[];
}


export interface IPosition {
    Longitude : number;
    Latitude : number;
}

export interface IWelcomePage {
    Hotel?: IItem[] | any[],
    CityGuide?: IItem[],
    HLocation?: IItem | any,
    CityLocation?: IItem[],
    WVideo?: IItem,
    WBgImg?: IItem,
    WGuestData?: IItem[]

}

export interface IMAWelcomePage {
  Hotel?: MItem[],
  CityGuide?: MItem[],
  HLocation?: MItem,
  CityLocation?: MItem[],
  WVideo?: MItem,
  WBgImg?: MItem,
  WGuestData?: MItem[]

}

export interface IBusiness {
    Hotel?: IITemModuleList[],
    Hotel2?: IITemModuleList[],
    CityGuide?: IITemModuleList[],
}

export interface IChat {
    Hotel?: IItem[]
}


export interface IConfigPage {
    Header?: IItem[],
    MainNenu?: IItem[] | any[],
    KeyMenu?: IItem[],
    Menus?: IItem[] | any[]
}


export enum DOOR_STATE
{
    UNKNOW = 0x0,
    NORMAL_CLOSE = 0x01,
    OFFICE_FIRST = 0x02,
    OFFICE = 0x03,
    MUR = 0x04,
    DND_LOGICAL_PRIVACY = 0x05,
    MECHANICAL_PRIVACY = 0x06,
    BLOCKED = 0x07,
    MUR_STARTED = 0x8
}

export enum DOOR_FUNCTION
{
    IsRoom = 0x0,
    IsEntrance = 0x01,
    IsGarage = 0x02
}

export enum PERSON_TYPE
{
    UNKNOW = 0,
    EMPLOYEE,
    GUEST,
    VISITOR,
    MEMBER,
    SYSTEM

}

export enum GUEST_TYPE
{
    UNSPECIFIED,
    NEW_GUEST,
    GUEST_COPY
}



export interface IDoorList
{
    DriD : number
    DrName? : string,
    DrStatus? : DOOR_STATE,
    DrFunction? : DOOR_FUNCTION,
    DrLocation?:string,
    DrImg?:string
}

export interface IPerson
{
    PersonID : number
    UserCommonID? : number
    _userId? : number,
    _Servs? : number[],
    _Tzs? : number[],
    _ExpDate?:Date,
    _InitDate?: Date,
    _SerialNum?: string,
    _PersonType : PERSON_TYPE,
    _GuestType :  GUEST_TYPE,
    _FirstName?: string,
    _LastName?: string,
    Gender?:number,
    isAuthenticated: boolean;
    _Enable2FA? : number,
    _Data5? : string,
    _SystemC? : string,
    _Data3? : string,
    _CheckOutDate? : Date,
}

/* this should be assign to an array variable, which is going to store the info of mutiple properties */
/* the menu multi-prop will be displayed on if this is more that 1 entry & the _Expdt valid */
export interface IMultiProperties
{
    _SystemC : number
    _Tok? : string,
    _PropName? : string,
    _PropAddress? : string,
    _Hash?: string,
    _Link?: string
}

export enum EMAIL_TYPE
{
    SKYACCESS,
    ALARM,
    SUPPORT
}

export interface IEmails
{
    _From? : string
    _To? : string,
    _Receiver? : string,
    _Sender? : string,

    _Subject? : string
    _Body? : string,
    _ExpDate? : Date,
    _EmailType? : EMAIL_TYPE,
    Data1? : string,
    Data2? : string,
    _CreationDate : Date
}

export interface IEmailTmplates
{
    _1FaTemplate? : string[],
    _2FaTemplate? : string[],
    MOBILEKEYING_SETTINGS? : string[],
    EMAIL_SETTINGS? : string[],
    emailTemplateID?: number[],
    _SysNumber : number;
}

export interface _LItems {
  ID: string,
  StaticTxt: string,
  VarTxt: string,
  VarTxt2: string,
  Enabled: boolean,
}

export interface _RItems {
  ID: string,
  StaticTxt: string,
  VarTxt: string,
  Enabled: boolean,
}
